import { Grid, MenuItem, Paper, TextField, Typography } from '@mui/material'

import {
  budgetPeriods,
  budgetYearTypes,
  fiscalYearStartMonths,
  getFiscalYearRangeLabel,
} from 'constants/budget'
import { BudgetYearType } from 'enums/budget'
import { t } from 'i18n'
import ManageBudgetLimitTypes from '../ManageBudgetLimitTypes/ManageBudgetLimitTypes'

export default function ManageBudgetGeneralForm(props) {
  const { formik, isDisabled } = props

  const isFiscal = formik.values.year_type === BudgetYearType.Fiscal
  const startMonth = Number(formik.values.fiscal_year_start_month) || 1

  const handleYearTypeChange = event => {
    const yearType = event.target.value

    formik.setFieldValue('year_type', yearType)

    // A calendar year is just the January-anchored case, so keep the anchor
    // consistent with the choice rather than leaving a stale fiscal month behind.
    if (yearType === BudgetYearType.Calendar) {
      formik.setFieldValue('fiscal_year_start_month', 1)
    }
  }

  return (
    <Paper sx={{ p: 3 }} key={'general'}>
      <Grid container spacing={2}>
        {/* <Grid item xs={12}>
          <Typography variant='h6' component='h3' fontWeight={500}>
            {t('budget.manageBudgetGeneralForm.title')}
          </Typography>
        </Grid> */}

        <Grid item xs={12}>
          <Grid container spacing={2} alignItems='center'>
            <Grid item xs={12} sm={isFiscal ? 4 : 6}>
              <TextField
                select
                data-cy='year_type'
                id='year_type'
                name='year_type'
                label={t('budget.manageBudgetGeneralForm.labels.yearType')}
                variant='outlined'
                value={formik.values.year_type ?? BudgetYearType.Calendar}
                required
                onChange={handleYearTypeChange}
                fullWidth
                margin='dense'
                disabled={isDisabled}
              >
                {budgetYearTypes.map(yearType => (
                  <MenuItem key={yearType.value} value={yearType.value}>
                    {yearType.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {isFiscal && (
              <Grid item xs={12} sm={4}>
                <TextField
                  select
                  data-cy='fiscal_year_start_month'
                  id='fiscal_year_start_month'
                  name='fiscal_year_start_month'
                  label={t(
                    'budget.manageBudgetGeneralForm.labels.fiscalYearStartMonth',
                  )}
                  variant='outlined'
                  value={startMonth}
                  required
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.fiscal_year_start_month &&
                    Boolean(formik.errors.fiscal_year_start_month)
                  }
                  helperText={
                    formik.touched.fiscal_year_start_month &&
                    formik.errors.fiscal_year_start_month
                  }
                  fullWidth
                  margin='dense'
                  disabled={isDisabled}
                >
                  {fiscalYearStartMonths.map(month => (
                    <MenuItem key={month.value} value={month.value}>
                      {month.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}

            <Grid item xs={12} sm={isFiscal ? 4 : 6}>
              <Typography variant='body2' color='text.secondary'>
                {t('budget.manageBudgetGeneralForm.labels.budgetYearRange')}
              </Typography>
              <Typography
                data-cy='budgetYearRange'
                variant='body1'
                color='text.primary'
                fontWeight={600}
              >
                {getFiscalYearRangeLabel(isFiscal ? startMonth : 1)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <TextField
                select
                id='period'
                name='period'
                label={t('budget.manageBudgetGeneralForm.labels.budgetPeriod')}
                variant='outlined'
                defaultValue=''
                value={formik.values.period ?? ''}
                required
                onChange={formik.handleChange}
                fullWidth
                margin='dense'
                disabled={isDisabled}
              >
                {budgetPeriods.map(period => (
                  <MenuItem key={period.value} value={period.value}>
                    {period.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <ManageBudgetLimitTypes {...props} />

            {/* <Grid item xs={12} sm={4}>
              <TextField
                select
                id='new_employees_budget_type'
                name='new_employees_budget_type'
                label={t(
                  'budget.manageBudgetGeneralForm.labels.budgetTypeForNewEmployees',
                )}
                variant='outlined'
                defaultValue=''
                value={formik.values.new_employees_budget_type ?? ''}
                required
                onChange={formik.handleChange}
                fullWidth
                margin='dense'
              >
                {budgetNewEmployeesBudgetTypes.map(newEmployeeBudgetType => (
                  <MenuItem
                    key={newEmployeeBudgetType.value}
                    value={newEmployeeBudgetType.value}
                  >
                    {newEmployeeBudgetType.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid> */}

            {/* {formik.values.new_employees_budget_type ===
              BudgetNewEmployeesBudgetType.Automatic && (
              <Grid item xs={12} sm={4}>
                <TextField
                  id='new_employees_base_amount'
                  name='new_employees_base_amount'
                  label={t(
                    'budget.manageBudgetGeneralForm.labels.amountPerNewEmployee',
                  )}
                  variant='outlined'
                  value={formik.values.new_employees_base_amount}
                  onChange={formik.handleChange}
                  required
                  fullWidth
                  margin='dense'
                  InputProps={{
                    inputComponent: MoneyInput,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )} */}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}
